import MainLayout from '@/common/components/layouts/MainLayout';
import { useQuery } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { Box } from 'styled-system/jsx';

import { useParams } from 'react-router-dom';
import { fileInformationEntryTabQueryOptions } from '@/modules/FileDetail/queries/fileInformationEntryTab/fileInformationEntryTabQueryOptions.ts';
import SummeryFile from '@/modules/FileDetail/components/summeryFile/SummeryFile.tsx';
import { FileInformationEntryTabQuery } from '@/modules/FileDetail/queries/fileInformationEntryTab/fileInformationEntryTabQuery.type.ts';
import FileInformationCard from '@/modules/FileDetail/components/fileInformation/entryTabs/FileInformationCard/FileInformationCard.tsx';
import CulpritInformation from '@/modules/FileDetail/components/fileInformation/entryTabs/CulpritInformationCard/CulpritInformationCard';
import DamagesInformation from '@/modules/FileDetail/components/fileInformation/entryTabs/DamagesInformationCard/DamagesInformationCard';
import InsurerInformation from '@/modules/FileDetail/components/fileInformation/entryTabs/InsurerInformationCard/InsurerInformationCard';

export default () => (
  <MainLayout title="مشخصات پرونده" header="titleHeader">
    <Information />
  </MainLayout>
);

const Information = () => {
  const { id } = useParams();
  const { data } = useQuery(fileInformationEntryTabQueryOptions(id!));

  return (
    <Box pt="20px">
      <SummeryFile />
      <Box mt="32px">
        {data?.map((item) => (
          <Box key={item.name}>{generateFileInformationEntryTab(item)}</Box>
        ))}
      </Box>
    </Box>
  );
};

const generateFileInformationEntryTab = (tab: FileInformationEntryTabQuery) => {
  const items: Record<string, ReactNode> = {
    file_information: <FileInformationCard title={tab.fa_name} />,
    culprit_information: <CulpritInformation title={tab.fa_name} />,
    damages_information: <DamagesInformation title={tab.fa_name} />,
    insurer_information: <InsurerInformation title={tab.fa_name} />,
  };
  return items[tab.name];
};
